<template>
  <div class="zhuyuanbaogao-record">
    <SelectInpatient @selectChange="selectChange">
      <template #date>
        <div class="title" @click="showCalendar=true">请选择日期<span v-if="date">:</span>{{ date }}<van-icon v-if="!date" class="iconclass" name="play" /></div>
      </template>
    </SelectInpatient>
    <van-tabs v-model="tabActive" :title-active-index-color="'blue'" class="item-wrap" @click="onClick">
      <van-tab title="检查报告" name="0">
        <van-loading v-show="jcLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jcList.length > 0 && !jcLoading" size="large">
          <van-cell v-for="item in jcList" :key="item.id" center :title="item.studyscripTion" :label="item.studyTime" is-link @click="toDetail(item, 1)" />
        </van-cell-group>
        <noData v-show="jcList.length === 0 && !jcLoading" title="暂无检查报告" />
      </van-tab>
      <van-tab title="检验报告" name="1">
        <van-loading v-show="jyLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jyList.length > 0 && !jyLoading" size="large">
          <van-cell v-for="item in jyList" :key="item.id" center :title="item.doctorAdvice" :label="item.testDate" is-link @click="toDetail(item, 2)" />
          <!-- <div class="yifabu">
            已发布
            </div> -->
        </van-cell-group>
        <noData v-show="jyList.length === 0 && !jyLoading" title="暂无检验报告" />
      </van-tab>
    </van-tabs>
    <van-calendar v-model="showCalendar" :min-date="minDate" :max-date="maxDate" :style="{ height: '70vh' }" type="range" :allow-same-day="true" color="#1989fa" @confirm="onConfirm" />
  </div>
</template>
<script>
import SelectInpatient from '@/components/selectInpatient'
import inpatientMinxins from './mixins'
export default {
  name: 'ZhuYuanBaoGaoRecord',
  components: {
    SelectInpatient
  },
  mixins: [inpatientMinxins],
  data() {
    return {
      minDate: new Date('2020/1/1'),
      maxDate: new Date(),
      jcLoading: false,
      jyLoading: false,
      jcList: [],
      jyList: [],
      date: '',
      startDate: '',
      endDate: '',
      showCalendar: false,
      activeIndex: '0',
      tabActive: '0' // 默认值
    }
  },
  created() {
    const startDate = this.formatDate(new Date(new Date().getTime() - 30 * 24 * 3600000))
    const endDate = this.formatDate(new Date())
    this.date = `${startDate}~${endDate}`
    this.startDate = startDate
    this.endDate = endDate
  },
  mounted() {},
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    getData() {
      if (!this.admissionNum) {
        return
      }
      if (this.tabActive === '0') {
        this.getJcList()
      } else {
        this.getJyList()
      }
    },
    getJcList() {
      const str = localStorage.getItem('userInfo')
      const idUse = JSON.parse(str)
      this.jcLoading = true
      const params = {
        startDate: this.startDate,
        endDate: this.endDate,
        patientID: this.patientIdHis,
        zyNo: this.admissionNum,
        userId: idUse.id
      }
      this.$Apis.getZYPatientZyExamineInfo(params).then(res => {
        this.jcLoading = false
        if (res.code === 200) {
          if (res.data.result) {
            this.jcList = res.data.result
          } else {
            this.jcList = []
            // this.$toast('暂无数据')
          }
        } else {
          this.jcList = []
          this.$toast.fail(res.message || '暂无数据')
        }
      }).catch(() => {
        this.jcList = []
        this.jcLoading = false
      })
    },
    getJyList() {
      const str = localStorage.getItem('userInfo')
      const idUse = JSON.parse(str)
      this.jyLoading = true
      const params = {
        startDate: this.startDate,
        endDate: this.endDate,
        zyNo: this.admissionNum,
        userId: idUse.id
      }
      this.$Apis.getZYPatientZyReport(params).then(res => {
        if (res.code === 200) {
          if (res.data.tables) {
            this.jyList = res.data.tables.reverse()
          } else {
            this.jyList = []
            // this.$toast('暂无数据')
          }
        } else {
          this.jyList = []
          this.$toast.fail(res.message || '暂无数据')
        }
        this.jyLoading = false
      }).catch(() => {
        this.jyList = []
        this.jyLoading = false
      })
    },
    onConfirm(date) {
      const [start, end] = date
      this.showCalendar = false
      this.date = `${this.formatDate(start)}/${this.formatDate(end)}`
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.getData()
    },
    toDetail(item, type) {
      if (type * 1 === 1) {
        localStorage.zyJcBaoGao = JSON.stringify(item)
        this.$router.push(`/zhuyuanbaogaodetail?id=${item.pacsStudyuniqueid}&type=${type}`)
      } else {
        this.$router.push(`/zhuyuanbaogaodetail?patientName=${item.patientName}&reportNo=${item.allBarCodes}&type=${type}`)
      }
    },
    onClick(index) {
      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>
.title{
  margin-top: .15rem;
  border-top: 1px solid #fff;
  padding: .15rem 0 .04rem;
  text-align: center;
  color: #FFFFFF;
    .iconclass{
      color: #FFFFFF;
      transform: rotateZ(90deg);
    }
  }
.item-wrap{
  margin: .1rem .15rem;
  position: relative;
  .yifabu{
    position: absolute;
    right: .5rem;
    top: 0;
    width: .5rem;
    height: .5rem;
    border-radius: 50%;
    border:1px solid red;
    color: red;
    transform: rotateZ(-20deg);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.zhuyuanbaogao-record{
  /deep/.van-tabs__line{
    background-color: #2B8CFF;
  }
  /deep/.van-tab--active{
    color: #2B8CFF;
  }
}
</style>
